/**
 * cart-sync.js — نغمة ستور
 * ------------------------------------------------------------
 * أداة سلة مشتركة حقيقية، مُستخلَصة من product-card.js (حيث كانت هذه
 * المنطقة مكتوبة أصلاً لأجل زر "إضافة سريعة" فقط) لتُستخدم أيضًا من
 * assets/product.js (نموذج المنتج الكامل في صفحة Product). الهدف: عدم
 * تكرار نفس منطق تحديث درج السلة/عدّاد السلة وحماية السباق في مكانين.
 *
 * يُحمَّل هذا الملف بلا شرط من layout/theme.liquid (مثل cart-drawer.js
 * تمامًا) — صغير الحجم، ولا يفعل شيئًا بمفرده سوى تعريف Naghmah.cartSync؛
 * لا مستمعي أحداث هنا إطلاقًا.
 *
 * الواجهة العامة:
 *   Naghmah.cartSync.getRoutesRoot()              → نص رابط الجذر الفعلي.
 *   Naghmah.cartSync.applyCartCount(count)         → يحدّث كل [data-cart-count].
 *   Naghmah.cartSync.refreshDrawerAndOpen(root, triggerButton)
 *       يطلب مقطع cart-drawer الحي عبر Section Rendering API، يستبدل
 *       العنصر القديم بالجديد، يحدّث العدّاد، ثم يفتح الدرج عبر
 *       Naghmah.cartDrawer.open(triggerButton) — أو يكتفي بتحديث العدّاد
 *       فقط إن كان Cart Drawer معطَّلاً (enable_cart_drawer=false). كل ذلك
 *       محمي بتسلسل طلب عام (drawerRequestSeq) وAbortController لإلغاء أي
 *       طلب سابق لم يكتمل بعد — نفس الحماية المطبَّقة سابقًا في
 *       product-card.js، بلا أي تغيير في السلوك، فقط استُخلصت إلى مكان
 *       واحد يشترك فيه أكثر من مستدعٍ (Quick Add وbuy-buttons معًا).
 */
(function () {
  "use strict";

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  var drawerRequestSeq = 0;
  var currentDrawerController = null;

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return Naghmah.routes.root;
  }

  function applyCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      if (count > 0) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
      if (/\d+/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d+/, String(count));
      } else {
        el.textContent = String(count);
      }
    });
  }

  function refreshCountFromCartJson(root, requestId, signal) {
    var fetchOptions = { headers: { Accept: "application/json" } };
    if (signal) fetchOptions.signal = signal;

    fetch(root + "cart.js", fetchOptions)
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (requestId != null && requestId !== drawerRequestSeq) return;
        if (cart) applyCartCount(cart.item_count);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        /* فشل صامت — تحديث عدّاد ثانوي فقط، لا داعٍ لإزعاج المستخدم. */
      });
  }

  function refreshDrawerAndOpen(root, button) {
    if (currentDrawerController) {
      currentDrawerController.abort();
    }
    drawerRequestSeq += 1;
    var requestId = drawerRequestSeq;
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    currentDrawerController = controller;
    var signal = controller ? controller.signal : undefined;

    var currentDrawer = Naghmah.cartDrawer.getDrawer();
    if (!currentDrawer) {
      refreshCountFromCartJson(root, requestId, signal);
      return;
    }

    var sectionId = currentDrawer.getAttribute("data-section-id");
    if (!sectionId) {
      refreshCountFromCartJson(root, requestId, signal);
      Naghmah.cartDrawer.open(button);
      return;
    }

    var sectionsUrl = root + "?section_id=" + encodeURIComponent(sectionId);
    var fetchOptions = { headers: { Accept: "text/html" } };
    if (signal) fetchOptions.signal = signal;

    fetch(sectionsUrl, fetchOptions)
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (requestId !== drawerRequestSeq) return;

        var liveDrawer = Naghmah.cartDrawer.getDrawer();
        if (!html || !liveDrawer) {
          refreshCountFromCartJson(root, requestId, signal);
          Naghmah.cartDrawer.open(button);
          return;
        }

        var parsed = new DOMParser().parseFromString(html, "text/html");
        var newDrawer = parsed.getElementById("CartDrawer");
        if (newDrawer && liveDrawer.parentNode) {
          liveDrawer.parentNode.replaceChild(newDrawer, liveDrawer);
          var countEl = newDrawer.querySelector("[data-cart-count]");
          if (countEl) {
            var digits = countEl.textContent.match(/\d+/);
            applyCartCount(digits ? parseInt(digits[0], 10) : 0);
          } else {
            refreshCountFromCartJson(root, requestId, signal);
          }
        } else {
          refreshCountFromCartJson(root, requestId, signal);
        }

        Naghmah.cartDrawer.open(button);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        if (requestId !== drawerRequestSeq) return;
        refreshCountFromCartJson(root, requestId, signal);
      });
  }

  Naghmah.cartSync = {
    getRoutesRoot: getRoutesRoot,
    applyCartCount: applyCartCount,
    refreshCountFromCartJson: refreshCountFromCartJson,
    refreshDrawerAndOpen: refreshDrawerAndOpen
  };
})();
